<template>
  <div>
    <!-- Prenos neiskorišćenih limita -->
    <div class="mb-4">
      <div class="subtitle-1 font-weight-bold text-uppercase mb-3 black--text">
        {{ $t("rollover_unused_limits") }}
      </div>

      <v-checkbox
        v-model="allowRollover"
        :label="$t('allow_rollover_to_next_period')"
        hide-details
        dense
        class="mt-0"
      ></v-checkbox>

      <!-- Conditional fields when rollover is enabled -->
      <v-card v-if="allowRollover" outlined class="mt-4 pa-4">
        <v-radio-group v-model="rolloverType" hide-details class="mt-0">
          <v-radio
            value="next_day"
            :label="$t('can_rollover_to_next_day')"
            class="mb-2"
          ></v-radio>

          <v-radio
            value="next_month"
            :label="$t('can_rollover_to_next_month')"
            class="mb-2"
          ></v-radio>

          <v-radio
            value="next_year"
            :label="$t('can_rollover_to_next_year')"
            class="mb-2"
          ></v-radio>

          <v-radio
            value="no_limit"
            :label="$t('no_time_limit_for_consumption')"
            class="mb-2"
          ></v-radio>

          <v-radio value="custom" :label="$t('custom_period')" class="mb-4"></v-radio>
        </v-radio-group>

        <v-row>
          <v-col cols="12" sm="6" v-if="rolloverType === 'custom'">
            <text-field
              :label="$t('max_rollover_days')"
              v-model="maxRolloverDays"
              type="number"
              dense
              outlined
              :hint="$t('max_rollover_days_hint')"
              persistent-hint
            />
          </v-col>
          <v-col cols="12" sm="6">
            <text-field
              :label="$t('max_accumulation')"
              v-model="maxAccumulation"
              type="number"
              dense
              outlined
              :hint="$t('max_accumulation_hint')"
              persistent-hint
            />
          </v-col>
        </v-row>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdditionalRulesTab",
  props: {
    wideLayout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      allowRollover: false,
      rolloverType: null,
      maxRolloverDays: 3,
      maxAccumulation: 5,
    };
  },
  watch: {
    allowRollover() {
      this.$emit("save");
    },
    rolloverType() {
      this.$emit("save");
    },
    maxRolloverDays() {
      this.$emit("save");
    },
    maxAccumulation() {
      this.$emit("save");
    },
  },
};
</script>
